import React from 'react'

import Age from '../sections/age'
import Level from '../sections/level'

export default function AgesFilters () {
  return (
    <div className='all-filters-content'>
      <Age />
      <Level />
    </div>
  )
}
